<template>
	<div>
		<div class="head">
			<img src="@/assets/headImg/headimg.jpg" style="width: 100%;
			vertical-align:top;" class="lunbo1" />
			<img src="../../assets/lunbo.jpg" style="width: 100%;" class="lunbo2">
		</div>
		<div class="success_box">
			<p class="text">
				<!-- <span>{{on_lineHead}}</span>{{on_line}} -->
				<span>诚挚欢迎您参与中华医学会第一次全国细菌真菌感染学术会议，您已成功完成注册，您可通过如下两种方式进参会费用缴纳：</span>
				<span>1、线上缴费（200元）：通过在线支付方式完成交费。</span>
				<span>2、线下缴费（300元）：会议报到当天现场进行交费。</span>
				<span>更多会议信息请访问大会官网：http://bisc2021.ganzhiyu.com/，如您对参会注册有任何疑问，请进入大会官网，通过联系我们模块进行详细咨询，感谢您的支持！</span>
			</p>
			<div class="flex" style="width: 90%;margin: 0 auto;">
				<div class="btn" @click="homePage">返回首页</div>
				<div class="btn" @click="toPayUrl">线上缴费（200元）</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				orderAmount: '200',
				userId: '',
				selete: '',
				on_line: '感谢您关注本次会议，请使用手机号+密码或短信验证方式登录会议网站，查看更多信息请访问大会官网http://bisc2021.ganzhiyu.com！',
				on_lineHead: '注册成功，'
			}
		},
		methods: {
			homePage() {
				this.$router.push({
					path: '/'
				})
			},
			toPayUrl() {
				console.log("user", JSON.parse(localStorage.getItem('user')));
				var user = JSON.parse(localStorage.getItem('user'));
				this.userId = user.user.userId;
				console.log("this.userId", this.userId);
				let cnt = {
					orderAmount: this.orderAmount, // String 金額
					userId: this.userId, // Long 用户编号
				};
				this.$api.pay(cnt, res => {
					if (res.data && res.data.rc == this.$util.RC.SUCCESS) {
						console.log("res", res.data.c);
						window.location = res.data.c
					}
				})
			},
			// signln() {
			// 	this.$router.push({
			// 		path: '/signIn'
			// 	})
			// },
			isselete() {
				if (this.selete == 2) {
					this.on_line = '感谢您关注本次会议，请您于4月8日会议报到当天前往会议现场进行线下交费，更多信息请访问大会官网http://bisc2021.ganzhiyu.com，首页右侧联系我们模块进行注册咨询',
						this.on_lineHead = '线下参会注册成功，'
				}
			},


		},
		mounted() {
			this.selete = this.$route.query.selete,
				this.isselete();

		}
	}
</script>

<style scoped lang="scss">
	@import '@/assets/style/style.scss';





	.text {
		font-size: 17px;
		// margin-left: 50%;
		// transform: translateX(-50%);
		margin-top: 20px;
		margin-bottom: 30px;
		color: #666
	}

	.text span {
		display: inline-block;
	}

	.btn {
		background-image: linear-gradient(to right, #5173ff, #3dbbff);
		width: 150px;
		height: 35px;
		line-height: 35px;
		border-radius: 5px;
		color: #fff;
		text-align: center;
		font-size: 15px;
		cursor: pointer;
	}

	.lunbo2 {
		display: none;
	}

	.isshow {
		visibility: hidden;
	}

	@media (max-width:500px) {
		.success_box {
			width: 90%;
			margin: 1.25rem auto;
		}

		.lunbo1 {
			display: none;
		}

		.lunbo2 {
			display: block;
		}

		.isshow {
			visibility: visible;
		}

		.btn {
			width: 45%;
			text-align: center;
		}

		.head {
			width: 100%;
		}

		.text {
			width: 90%;
			margin: 0 auto;
			padding-bottom: 1.25rem;
		}
	}

	@media (min-width:500px) {
		.success_box {
			width: 430px;
			height: 200px;
			// border: 1px solid #cfcfcf;
			margin-top: 150px;
			margin: 0 auto;
		}

		.head {
			width: 980px;
			margin: 0 auto;
			padding-right: 16px;
		}
	}
</style>
